<template>
  <div class="appointment">
    <navbar back fixed bg>
      <span slot="title">立即预约</span>
    </navbar>
    <div class="page-content">
      <form method="post" @submit.prevent="appointment">
        <div class="input-group-wrap">
          <div class="input-group">
            <div class="input-left">
              <label class="label">我的姓名</label>
            </div>
            <div class="input-right">
              <input type="text" v-model="name" class="form-control" placeholder="请输入您的姓名">
            </div>
          </div>
          <div class="input-group">
            <div class="input-left">
              <label class="label">手机号码</label>
            </div>
            <div class="input-right">
              <input type="tel" v-model="phone" class="form-control" placeholder="请输入手机号">
            </div>
          </div>
          <div class="input-group">
            <div class="input-left">
              <label class="label">城市</label>
            </div>
            <div class="input-right">
              <!-- <input type="tel" v-model="city" class="form-control" placeholder="请选择城市"> -->
              <select v-model="city" class="form-control" placeholder="请选择城市">
                <option value="">请选择城市</option>
                <option :value="city.cityCode" v-for="(city, index) in cityList" :key="index">{{city.cityName}}</option>
              </select>
            </div>
          </div>
          <div class="input-group">
            <div class="input-left">
              <label class="label">图形验证码</label>
            </div>
            <div class="input-right captInput">
              <input type="text" v-model="captText" class="form-control" placeholder="请输入图形验证码">
              <a href="javascript:;" @click="updateCapt" class="captImg"><img :src="captUrl"></a>
            </div>
          </div>
          <div class="input-group">
            <div class="input-left">
              <label class="label">短信验证码</label>
            </div>
            <div class="input-right smsInput">
              <input type="text" v-model="smsText" class="form-control" placeholder="请输入短信验证码">
              <button type="button" class="smsBtn" @click="getPhoneCapt" :disabled="btnDisable">{{btnText}}</button>
            </div>
          </div>
        </div>
        <div class="input-group btn-wrap">
          <!-- <a class="appointment-btn" href="javascript:;">立即预约</a> -->
          <input class="appointment-btn" type="submit" :disabled="submitBtnDisable" value="立即预约">
        </div>
        <!-- <div class="input-group">
          <div class="input-group-addon">
            <span class="iconfont">&#xe609;</span>
          </div>
          <input type="text" v-model="captText" class="form-control" placeholder="请输入图形验证码">
          <div class="input-group-btn">
            <a @click.prevent="updateCapt">
              <img class="icon" :src="captUrl">
            </a>
          </div>
        </div>
        <div class="input-group">
          <div class="input-group-addon">
            <span class="iconfont">&#xe606;</span>
          </div>
          <input type="password" v-model="password" class="form-control" placeholder="请输入密码">
        </div>
        <p class="help-text text-right">
          <router-link to="/auth/reset">忘记密码</router-link>
        </p>
        <div class="divider"></div>
        <div class="btn-group">
          <button type="submit" class="btn btn-round">{{btnText}}</button>
        </div>
        <div class="divider"></div>
        <div class="btn-group">
          <router-link class="btn btn-outline" to="/auth/register">注册</router-link>
        </div> -->
      </form>
    </div>
    <toast :show="toastShow" :text="toastText" @hidden="toastShow=false"></toast>
    <spinner :show="loading"></spinner>
  </div>
</template>

<script>
import Navbar from 'components/navbar/navbar'
import Toast from 'components/toast/toast'
import Spinner from 'components/spinner/spinner'
export default {
  components: {
    Navbar,
    Toast,
    Spinner
  },
  data () {
    return {
      toastShow: false,
      toastText: '',
      name: '',
      phone: '',
      city: '',
      captText: '',
      smsText: '',
      captUrl: '',
      btnText: '获取验证码',
      btnDisable: false,
      submitBtnDisable: false,
      loading: false,
      cityList: []
    }
  },
  created () {
    this.updateCapt()
    this.getCity()
  },
  methods: {
    appointment () {
      if (this.validate()) {
        let vm = this
        this.submitBtnDisable = true
        this.loading = true
        this.$ajax({
          url: '/quickLoanReservation.jhtml',
          params: {
            contact: vm.name,
            contactNumber: vm.phone,
            cityNo: vm.city,
            captId: vm.$cache.getCaptId(),
            captText: vm.captText,
            phoneCapt: vm.smsText
          },
          done (info, page, res) {
            // vm.$dialog(res.msg)
            vm.toastText = res.msg
            vm.toastShow = true
            setTimeout(() => {
              window.WeixinJSBridge.call('closeWindow')
            }, 3000)
          },
          faile (msg) {
            vm.$dialog(msg)
          },
          always () {
            vm.updateCapt()
            vm.loading = false
            vm.submitBtnDisable = false
          }
        })
      }
    },
    getCity () {
      let vm = this
      this.loading = true
      this.$ajax({
        url: '/getCitys.jhtml',
        done (list) {
          vm.cityList = list || []
        },
        fail (msg) {
          vm.$dialog(msg)
        },
        always (response) {
          vm.loading = false
        }
      })
    },
    updateCapt () {
      this.captUrl = this.$cache.updateCapt()
    },
    getPhoneCapt () {
      if (this.validate(true)) {
        let vm = this
        this.loading = true
        this.$ajax({
          url: '/sendPhoneCaptcha.jhtml',
          params: {
            phone: vm.phone,
            captId: vm.$cache.getCaptId(),
            captText: vm.captText,
            business: '1004'
          },
          done (info, page, res) {
            vm.$dialog(res.msg)
            vm.countdown()
          },
          fail (msg) {
            vm.$dialog(msg)
            vm.updateCapt()
          },
          always () {
            vm.loading = false
          }
        })
      }
    },
    countdown (t) {
      if (t === undefined) {
        t = 60
      }
      clearTimeout(this._timer)
      if (--t > 0) {
        this.btnText = `${t}秒后重试`
        this.btnDisable = true
        this._timer = setTimeout(() => {
          this.countdown(t)
        }, 1000)
      } else {
        this.btnText = '重新获取'
        this.btnDisable = false
      }
    },
    validate (isBreak) {
      if (!this.name) {
        this.toastText = '请输入您的姓名'
        this.toastShow = true
        return false
      }
      if (!this.phone) {
        this.toastText = '请输入手机号码'
        this.toastShow = true
        return false
      }
      if (!/^1\d{10}$/.test(this.phone)) {
        this.toastText = '请输入正确的手机号码'
        this.toastShow = true
        return false
      }
      if (!this.city) {
        this.toastText = '请选择城市'
        this.toastShow = true
        return false
      }
      if (!this.captText) {
        this.toastText = '请输入图形验证码'
        this.toastShow = true
        return false
      }
      if (isBreak) {
        return isBreak
      }
      if (!this.smsText) {
        this.toastText = '请输入短信验证码'
        this.toastShow = true
        return false
      }
      return true
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '../../common/css/mixmin'
.appointment
  .page-content
    overflow: auto
    padding-top: px2rem(20)
  .input-group-wrap
    background-color: #fff
    box-shadow: 0 px2rem(10) px2rem(15) #abb9c5
  .input-group
    width: 100%
    height: px2rem(100)
    line-height: px2rem(100)
    border-top: 1px solid #f0f2f3
    padding: 0 px2rem(24)
    box-sizing: border-box
    display: table
    .input-left
      font-size: px2rem(28)
      color: #234d73
      white-space: nowrap;
      // width: px2rem(200)
      // width: 100%
      height: 100%
      height: px2rem(100)
      text-align: justify
      display: table-cell
      label
        padding-right: 8px
        border-right: 1px solid #eae9e9
    .input-right
      // width: px2rem(470)
      width: 100%
      height: 100%
      padding-left: 10px
      height: px2rem(100)
      display: table-cell
      input, select
        width: 100%
        height: 100%
        padding: 0 px2rem(5)
        border: none
        font-size: px2rem(28)
        background-color transparent
    .btn-wrap
      padding: 0 px2rem(80)
      height: px2rem(140)
      background-color: transparent
    .appointment-btn
      display: block
      width: 100%
      height: px2rem(80)
      line-height: px2rem(80)
      margin: 0 auto
      border-radius: px2rem(8)
      background-color: #60c9c8
      font-size: px2rem(32)
      color: #fff
      text-align: center
      margin-top: px2rem(60)
      letter-spacing: 2px
      text-indent: 1px
      border: none
      box-shadow: 0 0 px2rem(4) rgba(18,119,163,0.75)
      &:disabled
        background-color: #aaa
    .captInput
      position: relative
      padding-right: px2rem(180)
      .captImg
        position: absolute
        width: px2rem(160)
        height: px2rem(100)
        right: 0
        top: 0
        img
          width: px2rem(160)
          margin-top: px2rem(14)
    .smsInput
      position: relative
      padding-right: px2rem(180)
      .smsBtn
        position: absolute
        padding: 0 px2rem(16)
        height: px2rem(40)
        right: 0
        top: px2rem(30)
        font-size: px2rem(24)
        border-radius: px2rem(20)
        border: none
        background-color: #40a3fd
        color: #fff
        box-shadow: 0 0 px2rem(4) rgba(18,119,163,0.75);
        &:disabled
          background-color: #aaa
</style>



// WEBPACK FOOTER //
// appointment.vue?98475a88